import httpClient from '/src/utils/httpClient';

export function updateHeaderApiCall({ id, imageSize, imageShape = '', image, link, name, view }) {
  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/header`, {
    id,
    image,
    imageSize: Number(imageSize),
    imageShape: imageShape,
    imageHyperlink: link,
    text: name,
    view,
  });
}
